import { RouterProvider } from "@tanstack/react-router";
import { router } from "../lib/router";
import { AuthUser } from "aws-amplify/auth";
import { AuthContextProvider, useAuthContext } from "../lib/use-auth";

interface RootProps {
  user: AuthUser;
  signOut: () => void;
}

export const Root = (props: RootProps) => {
  return (
    <AuthContextProvider cognitoUser={props.user} signOut={props.signOut}>
      <RouterProviderWithContext />
    </AuthContextProvider>
  );
};

function RouterProviderWithContext() {
  const authState = useAuthContext();
  return <RouterProvider router={router} context={{ authState }} />;
}
